import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireinpimprichichwad() {



  const cardData =
  {
    keyword: 'Bus Hire in Pimpri Chinchwad',
    heading: 'Sanavi Travels: Bus Hire in Pimpri Chinchwad',
    headingDescription: 'Sanavi Travels offers reliable Bus Hire in Pimpri Chinchwad, providing safe, comfortable, and spacious transportation for families, groups, corporate events, school excursions, weddings, and pilgrimage travel. Our fleet of well-maintained AC and non-AC buses, mini buses, and luxury coaches ensures ample seating, smooth rides, and sufficient luggage space for a hassle-free journey. With professional drivers, flexible one-way and round-trip bus hire packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Pimpri, Chinchwad, Akurdi, Nigdi, Wakad, and nearby PCMC areas, making it ideal for local travel, outstation trips, corporate transport, and group tours. Choose Sanavi Travels for trusted bus hire services in Pimpri Chinchwad, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical monument and a proud symbol of Maratha valor. Once the administrative center of the Maratha Empire, the fort features massive stone walls, grand gateways like the Delhi Darwaza, and sprawling courtyards. The evening light-and-sound show narrates the glorious history of the Peshwas, making it a must-visit heritage attraction."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a nationally significant monument closely associated with India’s freedom movement. Mahatma Gandhi and Kasturba Gandhi were imprisoned here during the Quit India Movement. Today, it houses a museum with personal belongings, photographs, and memorials, set amidst beautifully landscaped gardens that offer peace and reflection."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark. The richly adorned idol of Lord Ganesha attracts thousands of devotees daily, especially during Ganesh Chaturthi when grand celebrations take place. The temple trust is also known for its charitable and social initiatives."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fort famous for the bravery of Tanaji Malusare and the legendary battle fought for Chhatrapati Shivaji Maharaj. The fort offers panoramic views of the Sahyadri ranges and Pune city. Trekking enthusiasts and history lovers visit it for its scenic beauty and historical significance."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. Despite being located in the heart of the city, it offers a calm and spiritual atmosphere, showcasing ancient Indian architectural excellence."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts representing India’s cultural and artistic heritage. From traditional musical instruments to household antiques and sculptures, the museum provides deep insight into India’s rich craftsmanship and history."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering breathtaking views of the city after climbing 103 stone steps. The hilltop temple complex, built during the Peshwa era, is dedicated to Lord Shiva and Goddess Parvati and is especially popular during sunrise and sunset."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort attracts visitors from across the world. Known for meditation programs, wellness therapies, and peaceful gardens, it serves as a global center for mindfulness, relaxation, and spiritual growth."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. With flowing water streams, wooden bridges, and lush greenery, it offers a serene escape for families, walkers, and photography enthusiasts."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a popular leisure destination on the outskirts of Pune. Especially scenic during the monsoon season, it offers beautiful views of the reservoir and surrounding hills. The area is also a gateway to Sinhagad Fort and a favorite spot for evening outings."
  }
]
,



"services": [
{
"name": "Bus Hire in Pimpri-Chinchwad",
"description": "Bus Hire in Pimpri-Chinchwad offers reliable and professional bus rental services for local and outstation travel needs. Ideal for families, corporate groups, schools, and tourists, these buses are well-maintained, spacious, and operated by experienced drivers to ensure safe, comfortable, and punctual journeys across PCMC and nearby destinations."
},
{
"name": "Bus Rental PCMC",
"description": "Bus Rental PCMC provides flexible and convenient bus rental solutions tailored to different travel requirements. With multiple seating capacities, transparent pricing, and modern amenities, this service is suitable for weddings, corporate events, group tours, and long-distance travel from Pimpri-Chinchwad."
},
{
"name": "AC Bus Hire PCMC",
"description": "AC Bus Hire PCMC ensures a cool, comfortable, and relaxed travel experience with fully air-conditioned buses. Designed for long journeys and group travel, these buses feature comfortable seating, clean interiors, and smooth rides, making them ideal for tourists, families, and corporate travelers."
},
{
"name": "Luxury Bus PCMC",
"description": "Luxury Bus PCMC offers premium travel solutions with high-end buses equipped with pushback seats, ample legroom, and superior comfort. Perfect for VIP travel, weddings, corporate tours, and luxury outings, these buses enhance the overall travel experience with style and convenience."
},
{
"name": "Wedding Bus PCMC",
"description": "Wedding Bus PCMC specializes in guest transportation for weddings and family functions. With spacious seating, punctual pickups, and professional drivers, it ensures wedding guests travel together comfortably and arrive on time for all ceremonies and celebrations."
},
{
"name": "Corporate Bus PCMC",
"description": "Corporate Bus PCMC provides efficient and organized transportation for offices, factories, meetings, conferences, and corporate outings. Disciplined drivers, reliable schedules, and comfortable buses ensure smooth and stress-free corporate travel."
},
{
"name": "Outstation Bus PCMC",
"description": "Outstation Bus PCMC offers dependable bus services for long-distance travel to nearby cities and tourist destinations. Well-maintained vehicles, experienced drivers, and flexible travel plans make it ideal for family trips, group tours, and corporate travel."
},
{
"name": "Affordable Bus PCMC",
"description": "Affordable Bus PCMC delivers cost-effective bus rental services without compromising on safety or comfort. Suitable for schools, religious groups, families, and social events, it combines budget-friendly pricing with reliable transportation."
},
{
"name": "Chauffeur Driven Bus PCMC",
"description": "Chauffeur Driven Bus PCMC ensures a hassle-free travel experience with trained and professional drivers managing routes, traffic, and schedules. Passengers can relax and enjoy a smooth journey, making it ideal for events, tours, and group travel."
},
{
"name": "Best Bus Service PCMC",
"description": "Best Bus Service PCMC is known for punctual service, clean buses, and a customer-focused approach. Whether for weddings, corporate travel, tourism, or group outings, it guarantees reliable and comfortable transportation every time."
},
{
"name": "Tourist Bus PCMC",
"description": "Tourist Bus PCMC caters to travelers exploring Pimpri-Chinchwad, Pune, and nearby attractions. Flexible itineraries, spacious seating, and experienced drivers ensure a convenient and enjoyable sightseeing and travel experience."
},
{
"name": "Group Travel Bus PCMC",
"description": "Group Travel Bus PCMC provides organized transportation for large groups such as friends, families, corporate teams, and tour groups. Comfortable buses and coordinated planning ensure everyone travels together safely and conveniently."
},
{
"name": "Online Bus Booking PCMC",
"description": "Online Bus Booking PCMC allows quick and easy reservation of buses with instant confirmation. Multiple bus options, flexible schedules, and simple booking processes help travelers plan their journeys efficiently and stress-free."
},
{
"name": "Event Bus PCMC",
"description": "Event Bus PCMC offers dedicated transportation services for conferences, exhibitions, concerts, parties, and special events. Reliable scheduling, comfortable buses, and professional drivers ensure smooth transport of guests and participants."
},
{
"name": "Pimpri Chinchwad Travel Bus",
"description": "Pimpri Chinchwad Travel Bus provides complete travel solutions for local and outstation journeys. Combining comfort, safety, affordability, and professional service, it caters to tourists, families, corporate clients, and group travelers."
}
],
"tableData": [
["Bus Hire in Pimpri-Chinchwad", "Bus Rental PCMC"],
["AC Bus Hire PCMC", "Luxury Bus PCMC"],
["Wedding Bus PCMC", "Corporate Bus PCMC"],
["Outstation Bus PCMC", "Affordable Bus PCMC"],
["Chauffeur Driven Bus PCMC", "Best Bus Service PCMC"],
["Tourist Bus PCMC", "Group Travel Bus PCMC"],
["Online Bus Booking PCMC", "Event Bus PCMC"],
["Pimpri Chinchwad Travel Bus", "—"]
]
,



"whychoose": [
  {
    "WhyChooseheading": "Bus Hire in Pimpri Chinchwad with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides reliable and comfortable bus hire services in Pimpri Chinchwad for group travel, family outings, school trips, and more."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air-conditioned, and regularly serviced to ensure a smooth and comfortable journey throughout Pimpri Chinchwad and beyond."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with the Pimpri Chinchwad region, ensuring safe, timely, and pleasant travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers upfront and clear pricing for bus hire in Pimpri Chinchwad, including fuel, tolls, and driver allowances, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available around the clock to assist you with bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half-day, full-day, or customized bus hire packages to suit your schedule and travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for bus hire in Pimpri Chinchwad."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus hire services in Pimpri Chinchwad?',
    answer: 'Yes, Sanavi Travels offers reliable bus hire services in Pimpri Chinchwad for various travel needs.'
  },
  {
    question: 'How can I book a bus in Pimpri Chinchwad?',
    answer: 'You can easily book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for hire in Pimpri Chinchwad?',
    answer: 'Sanavi Travels offers a range of buses including mini buses, 20-seater, 32-seater, 45-seater, and 50-seater options to accommodate your group size.'
  },
  {
    question: 'Are the drivers experienced with routes in Pimpri Chinchwad?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with routes in and around Pimpri Chinchwad.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations in Pimpri Chinchwad?',
    answer: 'Absolutely. You can select your preferred pickup and drop-off locations within Pimpri Chinchwad.'
  },
  {
    question: 'Is the bus hire service in Pimpri Chinchwad available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock bus hire services in Pimpri Chinchwad to suit your travel schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for bus hire services?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bus hire bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your bus hire trip in Pimpri Chinchwad.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sachin Patil',
    feedback: 'Sanavi Travels provided an excellent bus hire service in Pimpri Chinchwad. Comfortable journey with a professional driver!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Aarti Deshpande',
    feedback: 'Great experience with Sanavi Travels bus hire in Pimpri Chinchwad—punctual, clean bus and courteous driver.',
    rating: 5
  }
];








































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire in Pimpri-Chinchwad - Sanavi Travels",
  "description": "Sanavi Travels provides AC, luxury, and chauffeur-driven buses on hire in Pimpri-Chinchwad for weddings, corporate events, group travel, and tourist trips. Affordable and reliable bus rental with online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "50"
  }
};








  return (
    <div>

<Helmet>
  <title>
    Bus Hire in Pimpri-Chinchwad | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Sanavi Travels provides AC, luxury, and chauffeur-driven buses on hire in Pimpri-Chinchwad for weddings, corporate events, group travel, and tourist trips. Affordable and reliable bus rental with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/127.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireinpimprichichwad;